// React Basic and Bootstrap
import React, { Component } from "react";
import { Row, Col } from "reactstrap";

class HowItWorks extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <section className="section bg-light">
          <div className="container">
            <Row className="justify-content-center">
              <Col className="text-center">
                <div className="section-title mb-4 pb-2">
                  <h4 className="main-title mb-4">Nuestra Metodología</h4>
                  <p className="text-muted para-desc mx-auto mb-0">
                    En{" "}
                    <span className="text-danger font-weight-bold">
                      DeveloCat
                    </span>{" "}
                    aplicamos ingeniería de software para el proceso de
                    desarrollo de tu sitio web
                  </p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-box with-line">
                <span>01.</span>
                <h3>Diseño del Sitio</h3>
                <p>
                  Realizamos una toma de requerimientos para comprender a fondo
                  las necesidades de tu empresa lo que es llevado al papel antes
                  de comenzar el desarrollo.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-box with-line">
                <span>02.</span>
                <h3>Desarrollo del Sitio</h3>
                <p>
                  Luego de comprender lo que buscas, nos enfocamos en llevar a
                  cabo el desarrollo de tu sitio, utilizando herramientas de
                  última generación.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-box with-line">
                <span>03.</span>
                <h3>Producto Final</h3>
                <p>
                  Una vez desarrollado tu sitio web será implantado en el
                  hosting y se conectará a tu nombre de dominio para que puedas
                  compartirlo con tus clientes.
                </p>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default HowItWorks;
